<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <a class="close-btn" mat-dialog-close><i class="ri-close-fill"></i></a>
    </div>
    <mat-dialog-content>
        <div class="text-center">
            <form novalidate>
                <img src="assets/images/mail-icon.svg" class="mb-4 m-auto d-table" />
                <h5 class="text-primary">Sent Link</h5>
                <p>Forgot password link has been sent successfully <br /> to your registered email. <span
                        class="text-blue">{{emailId}}</span></p>
                <button matButton="filled" type="button" class="btn dialog-btn-primary mt-4" (click)="close()">Check
                    Your Email</button>
            </form>
        </div>
    </mat-dialog-content>
</div>